<div class="chart-container">
    <highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions" [constructorType]="'stockChart'"
        [(update)]="updateFlag" style="width: 100%; height: 100%; display: block;"></highcharts-chart>
</div>